import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { AuthenticationService, CitizenService } from 'src/app/core/services';
import { AppSettings } from '../../../../core/models/app.settings';
import { Settings } from '../../../../core/models/app.settings.model';
import { MenuService } from '../menu.service';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VerticalMenuComponent implements OnInit {
  // tslint:disable-next-line:no-input-rename
  @Input('menuItems') menuItems;
  // tslint:disable-next-line:no-input-rename
  @Input('menuParentId') menuParentId;
  parentMenu: Array<any>;
  public settings: Settings;
  countOfPendingCitizensInCompound = 0;

  constructor(
    public appSettings: AppSettings,
    public menuService: MenuService,
    private citizenService: CitizenService,
    private authenticationService: AuthenticationService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.parentMenu = this.menuItems.filter(item => item.parentId === this.menuParentId);

    this.getCountOfPendingCitizensInCompound();

    this.menuService.compoundCitizen$.subscribe(res => {
      if (res) {
        this.getCountOfPendingCitizensInCompound();
      }
    });
  }

  onClick(menuId) {
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuItems, menuId);
  }

  private getCountOfPendingCitizensInCompound() {
    if (this.authenticationService.hasPermission(['Provider'])) {
      this.citizenService.getCountOfPendingCitizensInCompound().subscribe(result => {
        this.countOfPendingCitizensInCompound = result;
      });
    }
  }
}
